<template>
  <div class="content-block">
    <div class="asd-form-section">
      <div class="section-title">
        <h5>
          Provést reset hesla
        </h5>
        <div class="section-title-controls">
          <ActiveButton class="asd-btn-confirm"
                        :click="save"
          >
            <i class="fas fa-lock-open"></i>
          </ActiveButton>
        </div>
      </div>
      <div class="asd-form">
        <div>
          <div>
            <label>Token</label>
            <input v-model="tokenInput"
                   type="text"
                   class="asd-input"
                   :disabled="token !== null"
            />
          </div>
          <div>
            <label>Heslo</label>
            <input v-model="password"
                   type="text"
                   class="asd-input"
            />
            <Password v-model="password" :strengthMeterOnly="true"></Password>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Password from 'vue-password-strength-meter'
import EventBus from 'CORE/bus'
import ActiveButton from 'CORE/components/form/active-button'

export default {
    name: 'PasswordResetForm',
    components: {
        Password,
        ActiveButton,
    },
    props: {
        token: {
            type: String,
            required: false,
            default: _ => null,
        },
    },
    data() {
        return {
            tokenInput: '',
            password: '',
        }
    },
    computed: {
    },
    mounted() {
        if (this.token !== null) {
            this.tokenInput = this.token
        }
    },
    methods: {
        async save() {
            try {
                await this.$store.dispatch('sendResetPassword', {
                    token: this.tokenInput,
                    password: this.password,
                })
                EventBus.$emit('FLASH_OK', { message: `Heslo změněno.` })
                setTimeout(_ => this.$router.push('/'), 3000)
            } catch (e) {
                EventBus.$emit('FLASH_ERROR', e)
            }
        },
    },
}
</script>
